import { render, staticRenderFns } from "./Corte.vue?vue&type=template&id=2c09f6f3&scoped=true"
import script from "./Corte.vue?vue&type=script&lang=js"
export * from "./Corte.vue?vue&type=script&lang=js"
import style0 from "./Corte.vue?vue&type=style&index=0&id=2c09f6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c09f6f3",
  null
  
)

export default component.exports